<template>
    <div class="wrapper">
        <nav class="navbar navbar-expand navbar-dark bg-dark fixed-top justify-content-between">
            <div class="navbar-brand">
                Brandnamic Text
            </div>
            <ul class="navbar-nav mr-auto">
                <!-- Replace Foo with your resource name -->
                <li class="nav-item">
                    <router-link :to="{ name: 'UserList' }" class="nav-link">Users</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'OrganizationList' }" class="nav-link">Organizations</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'CookieList' }" class="nav-link">Cookies</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'CookiepresetList' }" class="nav-link">Cookie Presets</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'TextBlockList' }" class="nav-link">Text Blocks</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'ChannelList' }" class="nav-link">Channels</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'LogList' }" class="nav-link">Logs</router-link>
                </li>
            </ul>
            <ul v-if="user" class="navbar-nav ">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
                       aria-haspopup="true" aria-expanded="false">
                        Logged in as {{ user }}
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <a class="dropdown-item" href="#" v-on:click="logout">logout</a>
                    </div>
                </li>
            </ul>

        </nav>

        <div id="content">
            <router-view></router-view>
        </div>
    </div>
</template>
<style>
    .bn-navbar {
        background-color: #563d7c;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .05), inset 0 -1px 0 rgba(0, 0, 0, .1);
    }

    .bn-footer {
        background-color: #FDFDFD;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .05), inset 0 -1px 0 rgba(0, 0, 0, .1);
        border-top: 1px solid lightgray;
        padding: 10px;
        color:gray;
        font-size:small;

    }
    .bn-footerspan {
        margin-top: 5px;
        float:left;
    }


    .bn-modal {
        background-color: #00000055 !important;
    }

    .router-link-exact-active, .router-link-active {
        color: white !important;
    }

    .bn-tabs {
        margin-left: 15px;
        margin-right: 15px;
        margin: 15px;
        padding: 10px;
    }

    h1 {
        margin-left: 10px;
    }

    body {
        margin-bottom: 60px;
        margin-top: 60px;
    }

    form .form-group {
        padding-right: 15px;

    }

    form .form-group .control-label {
        width: 30%;
        padding-left: 15px;
        float: left;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    form .form-group .form-control {
        width: 70%;
        padding-right: 15px;
        margin-top: 5px;
        margin-bottom: 5px;

    }

    form .form-group input[type="checkbox"].form-control {
        width: 20px;
        height: 40px;
    }

    form div.form-group:hover {
        background-color: #FBFBFB;
    }

    form button[type="submit"] {
        margin-left: 15px;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #FDFDFD;

    }

    .table-hover tbody tr:hover {
        background-color: #FBFBFB;
    }

    .messages {
        position: fixed;
        top: 55px;
        z-index: 9999;
        border-radius: 0;
        opacity: 0.8;
        width: 100%;
    }

    .messages > div {

        /*left: 0px;*/
        width: 50%;
        margin: 0 auto;

    }

    .help-block {
        position: relative;
        background: #e37878;
        border-radius: .4em;
        margin-left: 30%;
        padding: 6px;
    }

    .help-block:after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: 6px solid transparent;
        border-bottom-color: #e37878;
        border-top: 0;
        margin-left: -6px;
        margin-top: -6px;

    }
    select.form-control{
        height:400px;
    }
    .help{
        color: lightgrey;
        margin-left: 30%;
        font-size: small;
    }

</style>

<script>

    export default {

        data: function () {
            return {
                user: localStorage.getItem('user')
            }
        },
        methods: {
            logout: function () {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                this.$router.go(0);
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/App.vue